import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { ConfirmDialog, DangerButton } from "../../UI/DesignStandards";

const DeleteWithConfirmation = ({
  onDelete,
  isLoggedIn,
  disabled,
  title = "Delete payout table",
  message = "Delete this table?",
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (!isLoggedIn) return null;

  return (
    <>
      <DangerButton
        onClick={() => setShowConfirmation(true)}
        disabled={disabled}
        icon={FaTrash}
        title={title}
      >
        Delete
      </DangerButton>
      <ConfirmDialog
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={() => {
          setShowConfirmation(false);
          onDelete();
        }}
        title={title}
        message={message}
        confirmText="Delete"
        cancelText="Keep table"
        variant="danger"
      />
    </>
  );
};

export default DeleteWithConfirmation;
